/*
 * Store user session globally on window
 * Used by banners to decide whether or not a banner should show to user
 */
export default async (context) => {
  const { store } = context;

  if (process.browser && store.state.session) {
    window.userSession = store.state.session;

    // csrf cookie not created for some reason when hitting /browse as a anon new user.  Hack!
    // csrf needed for Experiments
    const existingToken = document.cookie.indexOf('csrftoken=') > -1;

    if (!existingToken && store.state.csrfToken) {
      document.cookie = store.state.csrfToken;
    }
  }
};
